/**
 * Legacy `tokens(mode)` şeklini panel MUI paletine map eder.
 * Panel içi ekranlarda `theme.js` tokens() yerine kullanılmalıdır.
 */
import { getPanelMuiPalette } from "./panelCssVars";
import { PANEL_PRIMITIVE as P } from "./panelTokens.primitives";

export function getPanelLegacyColorsShim(mode = "light") {
  const isDark = mode === "dark";
  const pal = getPanelMuiPalette(isDark ? "dark" : "light");

  return {
    grey: {
      100: pal.textPrimary,
      200: pal.textBody,
      300: pal.textBody,
      400: pal.textMuted,
      500: pal.textMuted,
      600: pal.textLabel,
      700: pal.border,
      800: pal.border,
      900: pal.pageBg,
    },
    primary: {
      100: pal.textBody,
      200: pal.textMuted,
      300: pal.textLabel,
      400: pal.surface,
      500: pal.pageBg,
      600: pal.fillSubtle,
      700: pal.fillHover,
      800: pal.border,
      900: pal.textPrimary,
    },
    greenAccent: {
      100: isDark ? pal.accentSoft : "rgba(76, 206, 172, 0.12)",
      200: isDark ? pal.accentSoft : "rgba(76, 206, 172, 0.22)",
      300: isDark ? pal.accentText : P.tealText,
      400: isDark ? pal.accent : P.tealAccent,
      500: isDark ? pal.accent : P.tealAccent,
      600: isDark ? pal.accentHover : P.tealAccentHover,
      700: P.tealText,
      800: P.tealText,
      900: P.tealText,
    },
    blueAccent: {
      100: isDark ? "rgba(77, 124, 255, 0.12)" : P.blue100,
      200: isDark ? "rgba(77, 124, 255, 0.22)" : "rgba(59, 130, 246, 0.22)",
      300: isDark ? pal.blue : P.blue500,
      400: isDark ? pal.blue : P.blue500,
      500: isDark ? pal.blue : P.blue500,
      600: isDark ? pal.blue : P.blue600,
      700: P.blue600,
      800: P.blue600,
      900: P.blue600,
    },
    redAccent: {
      100: isDark ? "rgba(229, 72, 77, 0.12)" : "rgba(239, 68, 68, 0.12)",
      200: isDark ? "rgba(229, 72, 77, 0.22)" : "rgba(239, 68, 68, 0.22)",
      300: isDark ? pal.danger : P.red600,
      400: isDark ? pal.danger : P.red600,
      500: isDark ? pal.danger : P.red600,
      600: isDark ? pal.danger : P.red600,
      700: P.red600,
      800: P.red600,
      900: P.red600,
    },
  };
}
